import { composeRefs } from '@radix-ui/react-compose-refs';
import { forwardRef, Children, cloneElement } from 'react';
import { useEventLogger } from '../useEventLogger.mjs';
import { devLogger } from '../utils/devLogger.mjs';

const DEFAULT_CALLBACK_PROP_NAME = "onClick";
const ClickImpl = forwardRef(function ClickImpl2({
  action,
  eventProperties,
  children,
  callbackPropName = DEFAULT_CALLBACK_PROP_NAME,
  ...props
}, forwardedRef) {
  const { click } = useEventLogger();
  if (Children.count(children) !== 1) {
    devLogger.error(
      "EventLogger.Click \uCEF4\uD3EC\uB10C\uD2B8\uB294 children\uC774 \uD558\uB098\uC77C \uB54C\uB9CC \uC0AC\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4."
    );
    return children;
  }
  const childrenRef = getElementRef(children);
  return cloneElement(children, {
    ...props,
    [callbackPropName]: (...params) => {
      const typedProps = props;
      const callbackProp = typedProps[callbackPropName];
      click(
        action,
        typeof eventProperties === "function" ? eventProperties(...params) : eventProperties
      );
      typeof callbackProp === "function" && callbackProp(...params);
      const { [callbackPropName]: callbackPropFromChildren } = children.props;
      if (typeof callbackPropFromChildren === "function") {
        return callbackPropFromChildren(...params);
      }
    },
    ref: forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef
  });
});
const Click = ClickImpl;
function getElementRef(element) {
  let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}

export { Click };
//# sourceMappingURL=Click.mjs.map
